import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../shared/models/document.model';
import {DomSanitizer} from '@angular/platform-browser';


@Component({
  selector: 'app-document-thumbnail',
  templateUrl: './document-thumbnail.component.html',
  styleUrls: ['./document-thumbnail.component.scss']
})
export class DocumentThumbnailComponent implements OnInit {
  @Input() document: DocumentModel;

  constructor(public sanitizer: DomSanitizer) {
  }

  ngOnInit() {

  }
}
